export default "/_next/static/assets/hou-phone-mask_f0697dd486220079d2c8482edb578b4f.png";